import React from 'react';
import { number, func, string } from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import './ShowResultsButton.scss';

export default function ShowResultsButton({ nbHits, onClick, className }) {
    const rootClassName = classnames('show_results_button', className);

    return (
        <div className={rootClassName}>
            <button
                type="button"
                className="button button--primary product-info__select-color-button"
                onClick={onClick}
            >
                <FormattedMessage
                    id="listing.filters.showResultsMobileFilterPanel"
                    defaultMessage="Show {count} products"
                    values={{
                        count: nbHits,
                    }}
                />
            </button>
        </div>
    );
}

ShowResultsButton.propTypes = {
    nbHits: number.isRequired,
    onClick: func.isRequired,
    className: string,
};

ShowResultsButton.defaultProps = {
    className: '',
};
